<template>
     <v-theme-provider>
          <v-sheet
               class="pa-1"
               color="primary lighten-2"
               v-bind:class="{
                    'mt-0 mb-0': featured,
                    'mt-3 mb-3': !featured,
               }"
               v-bind:style="featured ? { height: '100%' } : ''"
          >
               <v-card
                    class="mx-auto"
                    v-bind:class="{
                         'elevation-24': featured,
                         'elevation-5': !featured,
                    }"
                    v-bind:style="featured ? { height: '100%' } : ''"
                    color="white"
               >
                    <v-row no-gutters>
                         <v-card-text>
                              <v-col
                                   cols="12"
                                   md="12"
                                   sm="12"
                                   class="text-center"
                              >
                                   <base-subheading
                                        :title="name"
                                        class="text-center"
                                   />
                                   <base-heading
                                        :title="price"
                                        class="text-center"
                                   />
                              </v-col>
                              <v-col
                                   cols="12"
                                   md="12"
                                   sm="12"
                                   class="text-center"
                                   v-if="description"
                              >
                                   <p>{{ description }}</p>
                              </v-col>
                              <v-col
                                   cols="12"
                                   md="12"
                                   sm="12"
                                   class="text-center"
                                   v-if="list"
                              >
                                   <v-list one-line>
                                        <template
                                             v-for="(item, index) in list"
                                             v-bind="index"
                                        >
                                             <div :key="index">
                                                  <v-list-item>
                                                       <v-list-item-content>
                                                            <v-list-item-subtitle
                                                                 v-html="item"
                                                            ></v-list-item-subtitle>
                                                       </v-list-item-content>
                                                  </v-list-item>
                                                  <v-divider
                                                       v-if="
                                                            index !=
                                                            list.length - 1
                                                       "
                                                  ></v-divider>
                                             </div>
                                        </template>
                                   </v-list>
                              </v-col>
                         </v-card-text>
                    </v-row>
                    <v-divider dark></v-divider>
                    <v-row justify="space-between pa-5" no-gutters>
                         <v-col cols="12" md="12" sm="12" class="text-center">
                              <v-btn
                                   v-if="!hideButton"
                                   tile
                                   large
                                   color="primary"
                                   :outlined="!featured"
                                   class="white--text"
                                   >Get Started</v-btn
                              >
                         </v-col>
                    </v-row>
               </v-card>
          </v-sheet>
     </v-theme-provider>
</template>

<script>
export default {
     name: 'BasePricingCard',
     props: {
          dark: Boolean,
          featured: {
               type: Boolean,
               default: false,
          },
          name: String,
          description: String,
          list: Array,
          price: String,
          color: {
               type: String,
               default: 'primary',
          },
          hideButton: {
               type: Boolean,
               default: false,
          },
     },
     data: () => ({}),
}
</script>
